<div class="navbar-wrapper">
  <div class="logo-container">
    <img src="assets/img/start-page/HVB_Logo.svg" class="cursor-pointer" alt="HVB Logo"/>
  </div>
</div>
<div class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
  <div class="left form-title-section-text">
    <h1>{{ 'createUser.createUserTitle' | translate }}</h1>
    <h4>{{ 'createUser.createUserSubtitle' | translate }}</h4>
  </div>
</div>

<ng-container *ngTemplateOutlet="noRoles"></ng-container>

<ng-template #noRoles>
  <div class="no-company-container d-flex flex-column justify-content-between">

    <div class="d-flex flex-column flex-grow-1 justify-content-center align-items-center no-company-text-container">
      <img src="assets/svg-icons/circle-actions-alert-info.svg" alt="">
      <span class="big-no-company-text mb-3">
        {{'createUser.errorRole.message'|translate}}
      </span>

      <span class="small-no-company-text">
        {{'createUser.errorRole.procedure'|translate}}
        <a href="mailto:support@hvb.services">support&#64;hvb.services</a>

        {{'\n\n' + ('createUser.errorRole.thanks'|translate)}}
      </span>
    </div>
    <div class="menu-button-container pt-3 w-100 justify-content-center">
      <button class="blue-border" (click)="authService.logout()">{{'loginPage.logout'|translate}}</button>
    </div>
  </div>
</ng-template>
